import gql from 'graphql-tag';

export const ME_QUERY = gql`
  query me{
    me{
      id
      name
      email
      roles{
        id
        name
      }
    }
  }
`;

export const GET_ALL_USERS = gql`
  query getAllUsers {
    getAllUsers{
      id
      email
      name
      firstName
      lastName
      roles{
        id
        name
      }
    }
  }
`;

export const GET_ALL_ROLES = gql`
  query getAllRoles {
    getAllRoles{
      id
      name
      description
    }
  }
`;

export const GET_ALL_COMMUNITIES = gql`
  query getAllCommunities {
    getAllCommunities{
      id
      name
      totalUnits
      managerTemp
      managerHomeTemp
      managerCellTemp
      maintenanceTemp
      maintenanceCellTemp
      maintenanceHomeTemp
      supervisorTemp
      faxNumber
      totalRAUnits
      officeAddressLine1
      officeAddressLine2
      officeAddressCity
      officeAddressState
      officeAddressZipCode
      propertyPhysicalAddressLine1
      propertyPhysicalAddressLine2
      propertyPhysicalAddressCity
      propertyPhysicalAddressState
      propertyPhysicalAddressZipCode
      afterHoursInstructions
      officePhoneNumbers
      typeTemp
      assetManagerTemp
      onesiteID
      legalName
      taxID
      county
      propertyTypeTemp
      emailAddress
      images
    }
  }
`

export const GET_ALL_COMMUNITIES_FIND_A_COMMUNITY = gql`
  query getAllCommunitiesFindACommunity {
    getAllCommunitiesFindACommunity{
      id
      name
      faxNumber
      propertyPhysicalAddressLine1
      propertyPhysicalAddressLine2
      propertyPhysicalAddressCity
      propertyPhysicalAddressState
      propertyPhysicalAddressZipCode
      officePhoneNumbers
      emailAddress
      images
    }
  }
`

export const GET_COMMUNITY = gql`
  query getOneCommunity($id: ID!){
  getOneCommunity(id: $id){
      id
      name
      legalName
      propertyPhysicalAddressLine1
      propertyPhysicalAddressLine2
      propertyPhysicalAddressZipCode
      propertyPhysicalAddressCity
      propertyPhysicalAddressState
      officePhoneNumbers
      emailAddress
      faxNumber
      taxID
      projectNumber
      totalUnits
      totalRAUnits
      managers{
        id
        email
        name
      }
      maintenanceTechs{
        id
        email
        name
      }
      fieldSupervisor{
        id
        email
        name
      }
      assetManager{
        id
        email
        name
      }
      staffAccountant{
        id
        email
        name
      }
      hoursMondayOpen
      hoursMondayClose
      hoursTuesdayOpen
      hoursTuesdayClose
      hoursWednesdayOpen
      hoursWednesdayClose
      hoursThursdayOpen
      hoursThursdayClose
      hoursFridayOpen
      hoursFridayClose
      hoursSaturdayOpen
      hoursSaturdayClose
      hoursSundayOpen
      hoursSundayClose
      propertyType{
        id
        name
      }
      attorney{
        id
      }
      buildings{
        id
        units{
          id
          handicapAccessable
          musaBlindSize
          musaFilterSize
          musaFilterType
          waterHeaterType
          waterHeaterGallons
          waterHeaterHasShutoffValve
          waterHeaterLocationInUnit
        }
      }
      waterMainShutoffLocation
      wifiPassword
      bankName
      acceptSec8
      sec8Agency
      sec8VoucherDeliveryMethod
      electricCompany{
        id
        type
        name
        phoneNumber
        emailAddress
        faxNumber
      }
      electricAccountNumber
      telecommunicationsProvider{
        id
        type
        name
        phoneNumber
        emailAddress
        faxNumber
      }
      telecommunicationsAccountNumber
      garbageCompany{
        id
        type
        name
        phoneNumber
        emailAddress
        faxNumber
      }
      garbageAccountNumber
      sewageCompany{
        id
        type
        name
        phoneNumber
        emailAddress
        faxNumber
      }
      sewageAccountNumber
      waterCompany{
        id
        type
        name
        phoneNumber
        emailAddress
        faxNumber
      }
      waterAccountNumber
      electricIncludedInRent
      waterIncludedInRent
      sewageIncludedInRent
      telecommunicationsIncludedInRent
      garbageIncludedInRent
      inspectionUsedAtCommunity{
        id
        inspectionType
      }
      usefulExtraInformation
      studentRulesApply
      allowBuildingToBuildingTransfers
      softwareLinks
      onesiteID
      occupancyTarget
      placedInServiceDate
      dateOfInitialOccupancy
      afterHoursInstructions
      mortgageLoanNumber
      auditor{
        id
      }
      fiscalYearEnd
      nonProfit
      lateFee
      lateFeeChargeDay
      certifiedMailFee
      courtCostsForEviction
      censusTract
      selfCertificationAllowed
      propertySpecificForms
      evictionDays
      dayLateFeeCharged
      setAsides{
        id
        name
      }
      officeAddressLine1
      officeAddressLine2
      officeAddressCity
      officeAddressState
      officeAddressZipCode
      gpTemp
      county
      typeTemp
      officeHoursTemp
      managerTemp
      managerHomeTemp
      managerCellTemp
      maintenanceTemp
      maintenanceHomeTemp
      maintenanceCellTemp
      supervisorTemp
      assetManagerTemp
      accountantTemp
      propertyTypeTemp
      images
    }
  }
`;



// WEBPACK FOOTER //
// ./src/constants/queries.js